import actionConstants from '../constants/ActionConstants';

const resetAllReducersAction = () => ({
  type: actionConstants.RESET_ALL_REDUCERS,
});

export default resetAllReducersAction;
